import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__